const config = {
  // env: process.env.NODE_ENV || 'development',
  // port: process.env.PORT || 3000,
  // jwtSecret: process.env.JWT_SECRET
  GOOGLE_TRACKING_ID: process.env.REACT_APP_GOOGLE_TRACKING_ID,
  //
  // ...and this snippet from src/config/index.ts:
}

export default config
